<template>
  <div
    class="flex min-h-[65px] w-full flex-col gap-2.5 rounded-[20px] bg-white-gray px-4 py-3.5 min-[1120px]:flex-row min-[1120px]:items-center min-[1120px]:justify-between xl:px-5 xl:py-4"
  >
    <template v-if="isMobile">
      <button
        type="button"
        class="flex min-w-0 max-w-full items-center gap-1.5 text-[17px] leading-[1.4] font-helvetica-400 text-gray-dark transition-colors cursor-pointer xl:gap-2 xl:text-[18px]"
        @click="open = true"
      >
        <span class="shrink-0">Период:</span>
        <span
          :title="periodLabel"
          class="min-w-0 truncate font-helvetica-700 text-orange"
          >{{ periodLabel }}</span
        >
        <SvgoIconComponentFIconFilterarrow class="h-[7px] w-[11px] shrink-0 text-orange transition-transform duration-200" :class="open ? 'rotate-180' : ''"></SvgoIconComponentFIconFilterarrow>
      </button>

      <transition name="finance-sheet-fade">
        <div
          v-if="open"
          class="fixed inset-0 z-[1300] bg-black/30 lg:hidden"
          @click.self="open = false"
        >
          <transition name="finance-sheet-slide">
            <section
              v-if="open"
              class="absolute inset-x-0 bottom-0 max-h-[88dvh] overflow-y-auto rounded-t-[28px] bg-white px-5 pb-[calc(24px+env(safe-area-inset-bottom))] pt-5 shadow-[0_-12px_32px_rgb(0_0_0_/_0.12)]"
            >
              <div
                class="mx-auto flex w-full max-w-[var(--layout-mobile-max-width)] flex-col gap-4"
              >
                <div class="flex items-center justify-between gap-4">
                  <p class="text-[24px] font-helvetica-700 text-gray-dark">
                    Период
                  </p>
                  <button
                    type="button"
                    class="relative flex h-10 w-10 items-center justify-center rounded-full border border-gray-border bg-white-gray text-gray-dark"
                    aria-label="Закрыть"
                    @click="open = false"
                  >
                    <span
                      class="absolute h-[1.5px] w-4 rotate-45 rounded-full bg-current"
                    ></span>
                    <span
                      class="absolute h-[1.5px] w-4 -rotate-45 rounded-full bg-current"
                    ></span>
                  </button>
                </div>

                <div class="rounded-[20px] border border-gray-border bg-white px-4 py-4 shadow-sm">
                  <div class="grid grid-cols-[minmax(0,1fr)_20px_minmax(0,1fr)] items-center gap-3 px-1">
                    <div class="flex flex-col gap-1">
                      <span class="text-[16px] font-helvetica-400 text-gray-dark">с</span>
                      <div
                        class="relative flex h-[48px] min-w-0 w-full items-center gap-2 rounded-[12px] border border-gray-border px-3 text-[14px] font-helvetica-400 text-gray-dark transition-colors cursor-text hover:border-gray-dark focus-within:border-gray-dark focus-within:ring-0"
                      >
                        <SvgoIconComponentRIconCalendar class="h-4 w-4 text-orange"></SvgoIconComponentRIconCalendar>
                        <input
                          v-model="inputFrom"
                          type="text"
                          inputmode="numeric"
                          placeholder=""
                          class="min-w-0 flex-1 border-0 bg-transparent text-[14px] font-helvetica-400 tabular-nums text-gray-dark placeholder:text-gray-light focus:outline-none caret-gray-dark"
                          @input="
                            (e) =>
                              onManualInput(
                                'from',
                                (e.target as HTMLInputElement).value,
                              )
                          "
                        />
                        <span
                          v-if="!inputFrom"
                          class="pointer-events-none absolute inset-0 flex items-center pl-[26px] text-[14px] font-helvetica-400 text-gray-light date-placeholder"
                        >__.__.____</span>
                      </div>
                    </div>
                    <div class="flex items-center justify-center self-center justify-self-center">
                      <span class="text-[18px] leading-none text-extra-text-color">-</span>
                    </div>
                    <div class="flex flex-col gap-1">
                      <span class="text-[16px] font-helvetica-400 text-gray-dark">по</span>
                      <div
                        class="relative flex h-[48px] min-w-0 w-full items-center gap-2 rounded-[12px] border border-gray-border px-3 text-[14px] font-helvetica-400 text-gray-dark transition-colors cursor-text hover:border-gray-dark focus-within:border-gray-dark focus-within:ring-0"
                      >
                        <SvgoIconComponentRIconCalendar class="h-4 w-4 text-orange"></SvgoIconComponentRIconCalendar>
                        <input
                          v-model="inputTo"
                          type="text"
                          inputmode="numeric"
                          placeholder=""
                          class="min-w-0 flex-1 border-0 bg-transparent text-[14px] font-helvetica-400 tabular-nums text-gray-dark placeholder:text-gray-light focus:outline-none caret-gray-dark"
                          @input="
                            (e) =>
                              onManualInput('to', (e.target as HTMLInputElement).value)
                          "
                        />
                        <span
                          v-if="!inputTo"
                          class="pointer-events-none absolute inset-0 flex items-center pl-[26px] text-[14px] font-helvetica-400 text-gray-light date-placeholder"
                        >__.__.____</span>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 flex flex-col gap-3">
                    <button
                      v-for="preset in presets"
                      :key="preset.value"
                      type="button"
                      class="flex h-[54px] items-center justify-center rounded-[14px] border px-4 text-[18px] leading-[1.3] font-helvetica-400 text-gray-dark transition-colors cursor-pointer"
                      :class="[
                        isActivePreset(preset.value)
                          ? 'bg-orange border-orange text-white'
                          : 'border-gray-border bg-white hover:border-gray-dark active:bg-selected-orange active:border-selected-orange active:text-white',
                      ]"
                      @click="applyPreset(preset)"
                    >
                      <span class="w-full text-center">{{ preset.label }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </transition>
        </div>
      </transition>
    </template>

    <UPopover
      v-else
      v-model:open="open"
      :content="{ side: 'bottom', align: 'start', sideOffset: 8 }"
    >
      <button
        type="button"
        class="flex min-w-0 max-w-full items-center gap-1.5 text-[17px] leading-[1.4] font-helvetica-400 text-gray-dark transition-colors cursor-pointer xl:gap-2 xl:text-[18px]"
      >
        <span class="shrink-0">Период:</span>
        <span
          :title="periodLabel"
          class="min-w-0 truncate font-helvetica-700 text-orange"
        >{{ periodLabel }}</span>
        <SvgoIconComponentFIconFilterarrow class="h-[7px] w-[11px] shrink-0 text-orange transition-transform duration-200" :class="open ? 'rotate-180' : ''"></SvgoIconComponentFIconFilterarrow>
      </button>

      <template #content="{ close }">
        <div
          class="w-[min(360px,calc(100vw-24px))] rounded-[10px] border border-gray-border bg-white-gray px-4 py-5 shadow-sm"
        >
          <div class="grid grid-cols-[minmax(0,1fr)_20px_minmax(0,1fr)] items-center gap-3 px-1">
            <div class="flex flex-col gap-1">
              <span class="text-[16px] font-helvetica-400 text-gray-dark">с</span>
              <div
                class="relative flex h-[40px] min-w-0 w-full items-center gap-2 rounded-[10px] border border-gray-border px-3 text-[14px] font-helvetica-400 text-gray-dark transition-colors cursor-text hover:border-gray-dark focus-within:border-gray-dark focus-within:ring-0"
              >
                <SvgoIconComponentRIconCalendar class="h-4 w-4 text-gray-dark"></SvgoIconComponentRIconCalendar>
                <input
                  v-model="inputFrom"
                  type="text"
                  inputmode="numeric"
                  placeholder=""
                  class="min-w-0 flex-1 border-0 bg-transparent text-[14px] font-helvetica-400 tabular-nums text-gray-dark placeholder:text-gray-light focus:outline-none caret-gray-dark"
                  @input="
                    (e) =>
                      onManualInput(
                        'from',
                        (e.target as HTMLInputElement).value,
                      )
                  "
                />
                <span
                  v-if="!inputFrom"
                  class="pointer-events-none absolute inset-0 flex items-center pl-[26px] text-[14px] font-helvetica-400 text-gray-light date-placeholder"
                >__.__.____</span>
              </div>
            </div>
            <div class="flex items-center justify-center self-center justify-self-center">
              <span class="text-[18px] leading-none text-extra-text-color">-</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="text-[16px] font-helvetica-400 text-gray-dark">по</span>
              <div
                class="relative flex h-[40px] min-w-0 w-full items-center gap-2 rounded-[10px] border border-gray-border px-3 text-[14px] font-helvetica-400 text-gray-dark transition-colors cursor-text hover:border-gray-dark focus-within:border-gray-dark focus-within:ring-0"
              >
                <SvgoIconComponentRIconCalendar class="h-4 w-4 text-gray-dark"></SvgoIconComponentRIconCalendar>
                <input
                  v-model="inputTo"
                  type="text"
                  inputmode="numeric"
                  placeholder=""
                  class="min-w-0 flex-1 border-0 bg-transparent text-[14px] font-helvetica-400 tabular-nums text-gray-dark placeholder:text-gray-light focus:outline-none caret-gray-dark"
                  @input="
                    (e) =>
                      onManualInput('to', (e.target as HTMLInputElement).value)
                  "
                />
                <span
                  v-if="!inputTo"
                  class="pointer-events-none absolute inset-0 flex items-center pl-[26px] text-[14px] font-helvetica-400 text-gray-light date-placeholder"
                >__.__.____</span>
              </div>
            </div>
          </div>

          <div class="mt-4 flex flex-col gap-2">
            <button
              v-for="preset in presets"
              :key="preset.value"
              type="button"
              class="flex h-[46px] items-center justify-center rounded-[10px] border px-4 text-[17px] leading-[1.4] font-helvetica-400 text-gray-dark transition-colors cursor-pointer xl:h-[48px] xl:text-[18px]"
              :class="[
                isActivePreset(preset.value)
                  ? 'bg-orange border-orange text-white'
                  : 'border-gray-border bg-white-gray hover:border-gray-dark active:bg-selected-orange active:border-selected-orange active:text-white',
              ]"
              @click="applyPreset(preset, close)"
            >
              <span class="w-full text-center">{{ preset.label }}</span>
            </button>
          </div>
        </div>
      </template>
    </UPopover>

    <button
      type="button"
      class="h-[42px] w-full min-w-[120px] rounded-[10px] border border-gray-dark px-4 text-[17px] leading-[1.4] font-helvetica-400 text-gray-dark transition-colors cursor-pointer hover:bg-white active:bg-selected-orange active:border-selected-orange active:text-white disabled:bg-gray-border disabled:border-gray-border disabled:text-gray-light disabled:hover:bg-gray-border disabled:hover:border-gray-border disabled:hover:text-gray-light disabled:cursor-not-allowed min-[1120px]:w-auto xl:h-[44px] xl:px-5 xl:text-[18px]"
      @click="$emit('show')"
    >
      Сформировать
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";

type Range = { from: string | null; to: string | null };
type Preset = {
  label: string;
  value: string;
  from: Date;
  to: Date;
  badge?: string;
};

const sanitizeInput = (val: string) => val.replace(/\D/g, "").slice(0, 8);

const formatDigitsToDisplay = (digits: string) => {
  let res = "";
  for (let i = 0; i < digits.length; i++) {
    res += digits[i];
    if (i === 1 || i === 3) res += ".";
  }
  return res;
};

const toISOFromDigits = (digits: string) => {
  if (digits.length !== 8) return null;
  const d = Number(digits.slice(0, 2));
  const m = Number(digits.slice(2, 4));
  const y = Number(digits.slice(4));
  if (m < 1 || m > 12 || d < 1 || d > 31) return null;
  const iso = `${String(y).padStart(4, "0")}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  const date = new Date(iso);
  if (isNaN(date.getTime())) return null;
  return iso;
};

const toDisplay = (iso: string | null) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (isNaN(date.getTime())) return "";
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yy = date.getFullYear();
  return `${dd}.${mm}.${yy}`;
};

const props = withDefaults(
  defineProps<{
    modelValue?: Range;
  }>(),
  {
    modelValue: () => ({ from: null, to: null }),
  },
);

const emit = defineEmits<{
  (e: "update:modelValue", value: Range): void;
  (e: "show"): void;
}>();

const open = ref(false);
const isMobile = ref(false);
const localFrom = ref<string | null>(props.modelValue.from);
const localTo = ref<string | null>(props.modelValue.to);
const inputFrom = ref<string>(
  props.modelValue.from ? toDisplay(props.modelValue.from) : "",
);
const inputTo = ref<string>(
  props.modelValue.to ? toDisplay(props.modelValue.to) : "",
);
const activePreset = ref<string | null>(null);
let mediaQuery: MediaQueryList | null = null;
let syncViewport: (() => void) | null = null;

const formatDateLabel = (value: string | null) => {
  if (!value) return "__.__.____";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "__.__.____";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  return `${dd}.${mm}.${yy}`;
};

const periodLabel = computed(() => {
  const fromLabel = formatDateLabel(localFrom.value);
  const toLabel = formatDateLabel(localTo.value);
  return `${fromLabel} – ${toLabel}`;
});

const startOfDay = (date: Date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};
const endOfDay = (date: Date) => {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
};

const toISO = (date: Date) => startOfDay(date).toISOString().slice(0, 10);

const today = startOfDay(new Date());
const presets = computed<Preset[]>(() => {
  const now = new Date();
  const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const currentMonthEnd = endOfDay(
    new Date(now.getFullYear(), now.getMonth() + 1, 0),
  );
  const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lastMonthEnd = endOfDay(new Date(now.getFullYear(), now.getMonth(), 0));
  const threeMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 2, 1);
  const yearStart = new Date(now.getFullYear(), 0, 1);
  const yearEnd = endOfDay(new Date(now.getFullYear(), 11, 31));

  return [
    { label: "Сегодня", value: "today", from: today, to: endOfDay(today) },
    {
      label: "Вчера",
      value: "yesterday",
      from: startOfDay(new Date(today.getTime() - 86400000)),
      to: endOfDay(new Date(today.getTime() - 86400000)),
    },
    {
      label: "Текущий месяц",
      value: "current-month",
      from: currentMonthStart,
      to: currentMonthEnd,
    },
    {
      label: "Прошлый месяц",
      value: "last-month",
      from: lastMonthStart,
      to: lastMonthEnd,
    },
    {
      label: "Последние 3 месяца",
      value: "last-3-months",
      from: startOfDay(threeMonthsAgo),
      to: endOfDay(currentMonthEnd),
    },
    {
      label: "Год",
      value: "year",
      from: startOfDay(yearStart),
      to: yearEnd,
    },
  ];
});

const emitRange = () => {
  emit("update:modelValue", { from: localFrom.value, to: localTo.value });
};

const onManualInput = (field: "from" | "to", val: string) => {
  const digits = sanitizeInput(val);
  const display = formatDigitsToDisplay(digits);
  if (field === "from") {
    inputFrom.value = display;
  } else {
    inputTo.value = display;
  }
  const iso = toISOFromDigits(digits);
  if (field === "from") {
    localFrom.value = iso;
  } else {
    localTo.value = iso;
  }
  if (iso) {
    activePreset.value = null;
    emitRange();
  }
};

const applyPreset = (preset: Preset | null, close?: () => void) => {
  if (!preset) return;
  localFrom.value = toISO(preset.from);
  localTo.value = toISO(preset.to);
  activePreset.value = preset.value;
  emitRange();
  close?.();
  open.value = false;
};

const isActivePreset = (value: string) => activePreset.value === value;

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      localFrom.value = val.from;
      localTo.value = val.to;
      inputFrom.value = toDisplay(val.from);
      inputTo.value = toDisplay(val.to);
    }
  },
);

onMounted(() => {
  if (!window.matchMedia) return;

  mediaQuery = window.matchMedia("(max-width: 1023px)");
  syncViewport = () => {
    isMobile.value = mediaQuery?.matches ?? false;
  };

  syncViewport();
  mediaQuery.addEventListener?.("change", syncViewport);
});

onBeforeUnmount(() => {
  if (!mediaQuery || !syncViewport) return;
  mediaQuery.removeEventListener?.("change", syncViewport);
});
</script>

<style scoped>
.date-placeholder {
  letter-spacing: 0.6px;
}

.finance-sheet-fade-enter-active,
.finance-sheet-fade-leave-active,
.finance-sheet-slide-enter-active,
.finance-sheet-slide-leave-active {
  transition: all 0.2s ease;
}

.finance-sheet-fade-enter-from,
.finance-sheet-fade-leave-to {
  opacity: 0;
}

.finance-sheet-slide-enter-from,
.finance-sheet-slide-leave-to {
  transform: translateY(18px);
  opacity: 0;
}
</style>
